// Google & YouTube inserts this frame after the theme has loaded.
// Name only its outer frame; preserve the app's own label when present.
(() => {
  const selector = 'iframe#merchantwidgetiframe';
  const label = (frame) => {
    if (!frame.getAttribute('title')?.trim() && !frame.getAttribute('aria-label')?.trim() && !frame.hasAttribute('aria-labelledby')) {
      frame.title = 'Información de la tienda en Google';
    }
  };
  const inspect = (node) => {
    if (node.nodeType !== Node.ELEMENT_NODE) return;
    if (node.matches(selector)) label(node);
    node.querySelectorAll(selector).forEach(label);
  };
  inspect(document.body);
  new MutationObserver((records) => {
    for (const record of records) record.addedNodes.forEach(inspect);
  }).observe(document.body, { childList: true, subtree: true });
})();
